export default __webpack_public_path__ + "img/footer/trust-pilot-logo.17fa4d30101ea47ffcb6fccf8ac683e9.svg";